module.exports = __webpack_public_path__ + "img/history_icon.8968a69f.svg";